import { render, staticRenderFns } from "./yushang.vue?vue&type=template&id=4f6d31cd&scoped=true"
import script from "./yushang.vue?vue&type=script&lang=js"
export * from "./yushang.vue?vue&type=script&lang=js"
import style0 from "./yushang.vue?vue&type=style&index=0&id=4f6d31cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d31cd",
  null
  
)

export default component.exports